import styled from 'styled-components';
import { device } from '../../../styles/breakpoints';

export const Body = styled.div`
  width: 100%;
`;

export const ForgotPasswordContainer = styled.div`
  @media ${device.desktopOnly} {
    display: flex;
    justify-content: center;
  }
`;

export const TrackerWrapper = styled.div`
  margin-top: 168px;
  margin-bottom: 80px;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  margin: 80px 128px;
  justify-content: start;
  align-items: center;

  @media ${device.desktopOnly} {
    max-width: 352px;
    width: 100%;
  }

  @media ${device.tablet} {
    margin: 80px 50px;
  }

  @media ${device.mobile} {
    margin: 80px 26px;
  }
`;
